module.exports = __webpack_public_path__ + "static/media/ketone-top.ab152ab6.png";